import React, { useState, useContext, useEffect } from "react";
import { IonItem, IonCard, IonSearchbar, IonSegment, IonSegmentButton, IonLabel, IonButtons, IonButton, IonIcon, IonList, IonCardHeader, IonCardContent, IonCardTitle, IonSelect, IonSelectOption } from "@ionic/react";
import { AppContext } from "../../context/app.context";
import ProcAttribDrag from "./ProcAttribDrag";
import { closeCircleOutline } from "ionicons/icons";
import CustomDrag from "./CustomDrag";
import { QuestionnaireActionTypes } from "../../reducers/questionnaire.reducer";
import '../drag/DragList.css';
import { getLookup } from "misc/phqHTTP";

const DragList = () => {
    const appContext = useContext(AppContext);
    const { questionnaire, setLookup, updateQuestionnaire } = appContext;
    const [listType, setlistType] = useState("preset");
    const [preset, setPreset] = useState('procattribs')
    const updateList = (value: string) => {
        setlistType(value);
        updateQuestionnaire(QuestionnaireActionTypes.UPDATE_SEARCH, '');
    }

    const removeGroup = () => {
        updateQuestionnaire(QuestionnaireActionTypes.REMOVE_GROUP, '');
    }

    const onPresetSelect = (val: string) => {
        if(val === 'healthissues') {
            removeGroup();
        }
        setPreset(val)
    }

    useEffect(() => {
        removeGroup();
        getLookup().then(res => {
            setLookup(res.data.result);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <IonCard>
            <IonCardHeader color="primary" className="item-header">
                <IonCardTitle>TOOLBOX</IonCardTitle>
            </IonCardHeader>
            <IonCardContent className="ion-no-padding">
                <IonSegment className='items-segment' onIonChange={e => { removeGroup(); updateList(e.detail.value!)}} value={listType ? listType : 'custom'}>
                    <IonSegmentButton value="preset">
                        <IonLabel>Preset</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="custom">
                        <IonLabel>Custom</IonLabel>
                    </IonSegmentButton>
                </IonSegment>
                <IonSearchbar className='search-bar' value={questionnaire.SearchedText} onIonChange={e => updateQuestionnaire(QuestionnaireActionTypes.UPDATE_SEARCH, e.detail.value!)} />
                {questionnaire.GroupSelected && (
                    <IonItem>
                        <IonLabel color="primary" className='searched-label'>
                            <b>{questionnaire.GroupSelected?.ProcAttribGroupID} - {questionnaire.GroupSelected?.Label}</b>
                        </IonLabel>
                        <IonButtons slot="end">
                            <IonButton onClick={(event) => { removeGroup(); event.stopPropagation() }}>
                                <IonIcon slot="icon-only" icon={closeCircleOutline} />
                            </IonButton>
                        </IonButtons>
                    </IonItem>
                )}
                <div className='items-list-container'>
                    <IonList>
                        {listType === 'custom' &&
                            <CustomDrag></CustomDrag>
                        }
                        {listType === 'preset' &&
                            <><IonSelect className="font-weight-bold"  interface="popover" hidden={!!questionnaire?.GroupSelected} value={preset} placeholder="Select Preset" onIonChange={e => onPresetSelect(e.detail.value)}>
                                    <IonSelectOption value="procattribs">Proc Attribs</IonSelectOption>
                                    <IonSelectOption value="healthissues">Health Issues</IonSelectOption>
                            </IonSelect>
                            <ProcAttribDrag preset={preset}></ProcAttribDrag></>
                        }
                    </IonList>
                </div>
            </IonCardContent>
        </IonCard>
    );
}
export default DragList;

